"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cartesian2dFloatPrecisionRangeBounder = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Constrains the data range so that the mapping into screen space is not worse than per pixel because of float precision.
 *
 * @remarks
 * The maximum zoom is a function of magnitude, larger values will have fewer bytes of precision. High dpi screens will
 * typically have a range between 2 and 4 times smaller than standard definition screens.
 */
class Cartesian2dFloatPrecisionRangeBounder {
    constructor(numberUtil, rangeScaleFactor) {
        this.numberUtil = numberUtil;
        DEBUG_MODE && rc_js_util_1._Debug.assert(rangeScaleFactor <= 1, "the range is already a maximum");
        const adjustedRange = this.numberUtil.bounds.slice();
        // the full range is twice float max
        adjustedRange.scalarMultiply(0.5, adjustedRange);
        adjustedRange.scaleRelativeTo(rangeScaleFactor, Cartesian2dFloatPrecisionRangeBounder.scaleOrigin, adjustedRange);
        adjustedRange.scalarMultiply(2, adjustedRange);
        this.maxBounds = adjustedRange;
        this.maxZoom = Math.pow(2, this.numberUtil.mantissaBits);
    }
    boundRange(o_dataRange, pixelRange, maxBounds = this.maxBounds) {
        const xMinRange = this.numberUtil.getPrecision(o_dataRange.getXMaxAbs()) * pixelRange.getXRange();
        const yMinRange = this.numberUtil.getPrecision(o_dataRange.getYMaxAbs()) * pixelRange.getYRange();
        o_dataRange.ensureMinRange(xMinRange, yMinRange);
        o_dataRange.bound(maxBounds);
    }
}
exports.Cartesian2dFloatPrecisionRangeBounder = Cartesian2dFloatPrecisionRangeBounder;
Cartesian2dFloatPrecisionRangeBounder.scaleOrigin = rc_js_util_1.Vec2.u8.factory.createOne(0, 0);
//# sourceMappingURL=cartesian2d-float-precision-range-bounder.js.map